<template>
  <v-container
    id="dashboard"
    tag="section"
  >
    <v-row class="elevation-5">
      <v-col
        cols="12"
      >
        <div class="section-header text-center">
          Check out all the plans we have to offer!
        </div>
      </v-col>
      <!--      already have address-->
      <v-col
        v-if="hasLocation"
        cols="12"
        sm="6"
      >
        <v-card
          flat
          style="height: 85%"
          class="px-3"
        >
          <v-row>
            <v-col
              cols="12"
            >
              <div class="section-subheader text-center">
                Service Location
              </div>
            </v-col>
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="calculatedStreet"
              >
                <template v-slot:label>
                  <div class="lbl-lg-textbox">
                    Street Address
                  </div>
                </template>
              </v-text-field>
            </v-col>
            <v-col
              cols="6"
            >
              <v-text-field
                v-model="publicLocation.city"
              >
                <template v-slot:label>
                  <div class="lbl-lg-textbox">
                    City
                  </div>
                </template>
              </v-text-field>
            </v-col>
            <v-col
              cols="3"
            >
              <v-text-field
                v-model="publicLocation.state"
              >
                <template v-slot:label>
                  <div class="lbl-lg-textbox">
                    State
                  </div>
                </template>
              </v-text-field>
            </v-col>
            <v-col
              cols="3"
            >
              <v-text-field
                v-model="publicLocation.postal_code"
              >
                <template v-slot:label>
                  <div class="lbl-lg-textbox">
                    Zip
                  </div>
                </template>
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              class="mb-n5"
            >
              <v-btn
                block
                class="btn-bold orange lighten-2 pb-0"
                style="color: #333333"
                @click="resetLocation"
              >
                RESET LOCATION
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <!--      prompt user to input address-->
      <v-col
        v-else
        cols="12"
        sm="6"
      >
        <v-card
          flat
        >
          <p class="section-text">
            Enter your address starting with the street number in the box below
          </p>
          <v-row>
            <v-col
              cols="12"
            >
              <GmapAutocomplete
                ref="tbAutocomplete"
                class="search-location"
                @place_changed="onPlaceChanged"
              >
              </GmapAutocomplete>
            </v-col>
            <v-col
              v-if="searchErrors.length > 0"
            >
              <v-alert
                text
                v-for="(error, i) in searchErrors"
                :key="i"
                color="deep-orange"
              >
                <b>{{error}}</b>
              </v-alert>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <!--      The MAP-->
      <v-col
        cols="12"
        sm="6"
      >
        <div
          style="width: 100%; height: 350px"
        >
          <l-map
            id="coveragemap"
            ref="coveragemap"
            style="height: 345px; width: inherit; z-index: 0"
            :zoom.sync="zoom"
            no-blocking-animations
            :center.sync="center"
          >
            <l-control-layers
              position="topright"
            ></l-control-layers>
            <l-tile-layer
              v-for="layer in tileProviders"
              :key="layer.name"
              :url="layer.url"
              :visible="layer.visible"
              :name="layer.name"
              layer-type="base"
            >
            </l-tile-layer>
            <l-marker
              :lat-lng="publicLocation"
              :options.sync="vwFootMarkerOptions"
            >
              <l-icon
                :icon-anchor="staticAnchor"
              >
                <img src="https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png">
              </l-icon>
            </l-marker>
          </l-map>
        </div>
      </v-col>
    </v-row>
    <v-row class="d-flex mt-4">
      <v-card
        flat
        v-if="hasLocation"
        class="mx-auto px-5"
        width="800px"
      >
        <v-row
          v-if="hasPlans"
          class="text-center mx-auto"
        >
          <div
            style="width: 100%"
            class="section-header text-center"
          >
            Available plans
          </div>
        </v-row>
        <v-row
          v-if="!hasPlans"
          class="d-flex"
        >
          <v-card
            flat
            class="mx-auto"
          >
            <div
              class="section-header text-center"
              style="width: 100%"
            >
              No Plans available at your location
            </div>
            <p class="section-text">
              We are sorry we are unable to provide internet service to your location but all is not lost.
              Provide your email or phone number and when coverage comes to your area we can let you know!
            </p>
          </v-card>
        </v-row>
      </v-card>
      <v-card
        v-else
        flat
        class="mx-auto"
        style="width: 100%"
      >
        <div class="section-header text-center">
          All Plans offered by {{ businessName }}
        </div>
      </v-card>
      <v-card
        v-for="(plan, idx) in availablePlans"
        :key="idx"
        class="mx-auto mx-10 px-3 mt-0 d-flex flex-column"
        style="min-height: 355px; min-width: 270px; max-width: 400px"
      >
        <v-card
          flat
          class="card-full-width text-center mt-0"
        >
          <span class="section-header">{{ plan.display_text }}</span>
          <v-divider
            class="mx-auto"
            style="width: 85%;"
          ></v-divider>
        </v-card>
        <v-card
          flat
          class="mx-auto mt-n1"
          style="width: 70%"
        >
          <div
            class="text-center section-subheader"
          >
            ${{ plan.price }}<span style="font-size: 12px">/mo</span>
          </div>
          <div style="font-size: .8em;">
            Actual speeds may vary. Taxes, govt. surcharges and one-time charges apply. Service subject to availability and all applicable terms and conditions.
          </div>
        </v-card>
        <v-card
          flat
          style="width: 85%"
          class="mx-auto mt-0"
        >
          <v-row
            v-for="(value, i) in plan.details.features"
            :key="i"
            class="section-bullets-sm mb-n4"
          >
            <v-col
              cols="2"
            >
              <v-icon
                color="success"
                large
              >
                mdi-check
              </v-icon>
            </v-col>
            <v-col
              cols="10"
              class="justify-center"
            >
              {{ value }}
            </v-col>
          </v-row>
        </v-card>
        <v-card
          flat
          class="mt-auto"
        >
          <v-btn
            v-if="hasLocation"
            fab
            block
            tile
            bottom
            elevation="11"
            color="success"
            class="btn-order"
            @click="doSelectPlan(plan)"
          >
            Order NOW
          </v-btn>
          <v-btn
            v-else
            fab
            block
            tile
            bottom
            elevation="11"
            color="warning"
            class="btn-order"
          >
            Search Address Above
          </v-btn>
        </v-card>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import { PUBLIC_PROCESS_GOOGLE_PLACE, PUBLIC_GET_PLANS } from '../../store/actions.types'
  import {
    SIGNUP_RESET_LOCATION,
    SIGNUP_SET_SELECTED_PLAN,
  } from '../../store/mutations.types'
  import { LControlLayers, LIcon, LMap, LMarker, LTileLayer } from 'vue2-leaflet'
  import 'leaflet/dist/leaflet.css'
  import basicMixin from '../../mixins/basic'

  export default {
    name: 'Plans',
    components: {
      // VueGoogleAutocomplete,
      // PowAutocompleteMap,
      'l-map': LMap,
      // 'l-geo-json': LGeoJson,
      'l-tile-layer': LTileLayer,
      'l-marker': LMarker,
      // 'l-layer-group': LLayerGroup,
      'l-control-layers': LControlLayers,
      'l-icon': LIcon,
      // 'l-wms-tile-layer': LWMSTileLayer,
      // 'l-tooltip': LTooltip,
    },
    mixins: [basicMixin],

    data () {
      return {
        planFeatures: [
          {
            feature: 'Unlimited Data!',
            plan_15: true,
            plan_55: true,
            plan_105: true,
          },
          {
            feature: 'Email & Chat',
            plan_15: true,
            plan_55: true,
            plan_105: true,
          },
          {
            feature: 'Social Media',
            plan_15: true,
            plan_55: true,
            plan_105: true,
          },
          {
            feature: 'Streaming Music',
            plan_15: true,
            plan_55: true,
            plan_105: true,
          },
          {
            feature: 'Remote Learning',
            plan_15: false,
            plan_55: true,
            plan_105: true,
          },
          {
            feature: 'Corporate VPN',
            plan_15: false,
            plan_55: true,
            plan_105: true,
          },
          {
            feature: 'Ultimate gaming performance',
            plan_15: false,
            plan_55: false,
            plan_105: true,
          },
          {
            feature: 'Power multiple users in your home simultaneously',
            plan_15: false,
            plan_55: false,
            plan_105: true,
          },
        ],
        tileProviders: [
          {
            name: 'Satellite Mapbox Base',
            visible: true,
            attribution: '',
            url: 'https://api.mapbox.com/styles/v1/jdietrich/ckb86tww8021u1imi6yc0j0up/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiamRpZXRyaWNoIiwiYSI6ImNrYjdjOTY4YTA0ZGIzMHM3MDVtYW54dHMifQ.G39kMitwQre3y48CHIGhwQ',
          },
        ],
        zoom: 12,
        radius: 3,
        center: [37.79442939780746, -120.9921788731105],
        vwFootMarkerOptions: {
          riseOnHover: true,
        },
        markerDetails: {
          lat: 37.794603,
          lng: -120.99223,
        },
        markerConfirmed: false,
        staticAnchor: [12, 41],
        searchErrors: [],
      }
    },
    computed: {
      ...mapGetters(['publicPlans']),
      ...mapGetters({
        publicLocation: 'signupLocation',
        publicAvailablePlans: 'signupAvailablePlans',
      }),
      calculatedStreet: function () {
        return this.publicLocation.street_number + ' ' + this.publicLocation.route
      },
      hasLocation: function () {
        if (this.publicLocation.street_number &&
          this.publicLocation.street_number.length > 0 &&
          this.publicLocation.lat &&
          this.publicLocation.lng) {
          return true
        }
        return false
      },
      hasPlans: function () {
        if (this.hasLocation && this.availablePlans.length > 0) {
          return true
        }
        return false
      },

      availablePlans: function () {
        if (this.hasLocation) {
          return this.publicAvailablePlans
        }
        return this.publicPlans
      },
    },
    watch: {
      publicLocation (n, o) {
        console.log('New Location:', n)
        if (n.street_number &&
          n.street_number.length > 0 &&
          n.lat &&
          n.lng) {
          this.searchErrors = []
        } else if (n.lat &&
          n.lng) {
          this.searchErrors.push('Location must have a street number')
        }
      },
    },

    async created () {
      await this.init()
    },
    methods: {
      ...mapActions({
        processPlaceChanged: PUBLIC_PROCESS_GOOGLE_PLACE,
        getPlans: PUBLIC_GET_PLANS,
      }),
      ...mapMutations({
        resetLocation: SIGNUP_RESET_LOCATION,
        selectPlan: SIGNUP_SET_SELECTED_PLAN,
      }),
      async init () {
        this.setMap()
        await this.getPlans()
      },
      setMap () {
        if (this.publicLocation.street_number &&
          this.publicLocation.street_number.length > 0 &&
          this.publicLocation.lat &&
          this.publicLocation.lng) {
          this.center = [this.publicLocation.lat, this.publicLocation.lng]
          this.zoom = 20
        } else {
          this.center = [37.79442939780746, -120.9921788731105]
          this.zoom = 12
        }
      },
      async onPlaceChanged (addressData) {
        // eslint-disable-next-line camelcase
        console.log('Place Changed', addressData)
        await this.processPlaceChanged(addressData)
        this.init()
      },
      async doSelectPlan (plan) {
        console.log('Plan selected', plan)
        this.selectPlan(plan.value)
        this.$router.push('/signup')
      },
    },
  }
</script>
